import { render, staticRenderFns } from "./popoverContent.vue?vue&type=template&id=1b2170be&scoped=true"
import script from "./popoverContent.vue?vue&type=script&lang=js"
export * from "./popoverContent.vue?vue&type=script&lang=js"
import style0 from "./popoverContent.vue?vue&type=style&index=0&id=1b2170be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2170be",
  null
  
)

export default component.exports